import React from 'react';
import { RegularPriceRow } from './regular';
import { usePriceRowContext } from '../../price-row-context';
import { useDispatch } from 'react-redux';
import {
  productPriceClick,
  productClickOutBounce,
} from 'src/areas/product/actions/product';
import { IPriceRow } from '../types';
import { ProductPriceClickStatus } from 'src/areas/product/actions/types';

export const PriceRow: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceRow>
>> = props => {
  const { item, index } = props;
  const { productId } = usePriceRowContext();
  const rowKey = `${item.id}-${index}`;
  const dispatch = useDispatch();

  return (
    <RegularPriceRow
      key={rowKey}
      onClickOutBounce={() => {
        dispatch(productClickOutBounce(productId, item.id));
      }}
      onPriceClick={(
        featured: boolean,
        status: ProductPriceClickStatus,
        isAlternative: boolean
      ) => {
        // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
        // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
        dispatch(
          productPriceClick(productId, item, featured, status, isAlternative)
        );
      }}
    />
  );
};
